import { Component, OnInit } from "@angular/core";
import { EventService } from "src/app/services/event.service";

@Component({
  selector: "app-iframe-integration",
  templateUrl: "./iframe-integration.component.html",
})
export class IframeIntegrationComponent implements OnInit {
  url: string;

  constructor(private readonly eventService: EventService) {
    const widgetUrl = JSON.parse(localStorage.getItem("WIDGET_URL") as string);

    if (!widgetUrl) {
      throw new Error("Widget URL shoud be defined");
    }

    this.url = widgetUrl;
  }

  ngOnInit(): void {
    window.addEventListener("message", (e) => {
      if (e.origin === new URL(this.url).origin) {
        this.eventService.handleOpenBankingEvents(e);
      }
    });
  }
}
